import { FC, useState } from 'react';
import { Box } from '@mui/material';

import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import { Input, inputType, inputSize } from '../../../../../packages/ui/atoms/input';

import Chatbots from '../../../member-detail/components/Chatbots';

import { useStyles } from '../past-appointments-drawer/PastAppointmentsDrawer.styles';

const ChatbotsDrawer = ({ open, onClose, isNoDrawer, items = [], appointment }) => {
  const classes = useStyles();
  const [searchKey, setSearchKey] = useState('');

  const renderContent = () => {
    return (
      <Box className={classes.container}>
        <Box className={classes.searchWrap}>
          <Input
            variant={inputType.SEARCH}
            className={classes.searchInput}
            placeholder="Search chatbot"
            size={inputSize.M}
            value={searchKey}
            onChange={setSearchKey}
          />
        </Box>
        <Box className={classes.appointments}>
          <Chatbots showHeader={false} participantId={appointment.participantId} searchKey={searchKey} />
        </Box>
      </Box>
    );
  };

  if (isNoDrawer) {
    return renderContent();
  }

  return (
    <Drawer
      open={open}
      title="Chatbots"
      subTitle={`${items.length} total`}
      onClose={onClose}
      variant={drawerType.FORM}
      className={classes.drawer}
      footer={<div />}
    >
      {renderContent()}
    </Drawer>
  );
};

export { ChatbotsDrawer };
